module.exports = __webpack_public_path__ + "bz.f6c04e11e4bec5ff8815.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bz.svg
// module chunks = styles